import { TRANSACTION_TYPES } from '../utils/constants';

const plansRoutes = [

    {
        path: '/plans',
        name: 'PlansPage',
        component: () => import('../views/plans/PlansComponent.vue'),
        meta: {
            requiresAuth: true,
            roles: ['SUPERADMIN'],
            module: 'plans',
        },
    },

    {
        path: '/plans/create',
        name: 'PlansCreatePage',
        component: () => import('../views/plans/PlansManagerComponent.vue'),
        props: { type: TRANSACTION_TYPES.CREATE },
        meta: {
            requiresAuth: true,
            roles: ['SUPERADMIN'],
            module: 'plans',
        },
    },

    {
        path: '/plans/edit/:planId',
        name: 'PlansEditPage',
        component: () => import('../views/plans/PlansManagerComponent.vue'),
        props: (route) => ({ type: TRANSACTION_TYPES.EDIT, planId: route.params.planId }),
        meta: {
            requiresAuth: true,
            roles: ['SUPERADMIN'],
            module: 'plans',
        },
    },

    {
        path: '/plans/show/:planId',
        name: 'PlansShowPage',
        component: () => import('../views/plans/PlansManagerComponent.vue'),
        props: (route) => ({ type: TRANSACTION_TYPES.SHOW, planId: route.params.planId }),
        meta: {
            requiresAuth: true,
            roles: ['SUPERADMIN'],
            module: 'plans',
        },
    },

    {
        path: '/plans/compare',
        name: 'PlansComparePage',
        component: () => import('../views/plans/PlansCompareComponent.vue'),
        meta: {
            requiresAuth: true,
            roles: ['SUPERADMIN'],
            module: 'plans',
        },
    },

];

export default plansRoutes;
